import { useQuery } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';
import { FlowsSession } from '../types/FlowsSession';

interface Params {
  sessionId: string;
}

const getFlowsSessionById = async ({ sessionId }: Params) => {
  const { data, isError } = await wgApi.get<FlowsSession>(
    `v1/api/conversations/${sessionId}`,
  );
  if (isError) throw new Error();
  return data;
};

export const getUseFlowsSessionQKey = (sessionId: string) => [
  'flows',
  'session',
  sessionId,
];

export const useFlowsSession = (sessionId?: string) => {
  return useQuery(
    getUseFlowsSessionQKey(sessionId!),
    () => getFlowsSessionById({ sessionId: sessionId! }),
    { enabled: !!sessionId },
  );
};
